export enum GameStatuses {
  used = 5,
  submitted = 4,
  saved = 1,
  draft = 2,
}
